module.exports = __webpack_public_path__ + "static/media/bird_bidding_app_logo5.6ea4c9c9.png";